<template>
  <div class="start-menu">
    <div class="logo">
      <div>
        <span>c</span>
      </div>
      <div>
        <span>c</span>
      </div>
      <div>
        <span>c</span>
      </div>
      <div>
        <span>o</span>
      </div>
      <div>
        <span>m</span>
      </div>
      <div>
        <span>b</span>
      </div>
      <div>
        <span>o</span>
      </div>
    </div>
    <router-link to="game" :runningInApp="runningInApp" class="button" @click.native="$emit('closeChangeName')">Play</router-link>
    <div class="toolbar">
      <div>
        <router-link :to="{name: 'settings'}">
          <i class="fa fa-cogs" aria-hidden="true" @click="changePlayerName = true"></i>
        </router-link>
      </div>
      <div>
        <router-link :to="{name: 'help'}">
          <i class="fa fa-question-circle" aria-hidden="true"></i>
        </router-link>
      </div>
      <div>
        <router-link :to="{name: 'highscore'}">
          <i class="fa fa-trophy" @click="showHighscore = true" aria-hidden="true"></i>
        </router-link>
      </div>
    </div>
    <div class="status-bar">
      <div class="players-online">
        {{clients}}
        <p>Players online</p>
      </div>
      <div class="games-played">
        {{totalGames}}
        <p>Games played</p>
      </div>
    </div>
    <div class="share">
      <div class="fb-like" data-href="https://www.facebook.com/cccombogame/" data-layout="button_count" data-action="like" data-size="large" data-show-faces="true" data-share="true"></div>
    </div>
    <div class="game-version">
      <router-link :to="{name: 'changelog'}">{{gameVersion}}</router-link>
    </div>
    <div class="ads">
      <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-9072364747594224" data-ad-slot="3124355986" data-ad-format="auto"></ins>
    </div>
  
  </div>
</template>

<script>
export default {
  name: 'start',
  props: {
    clients: [String, Number],
    totalGames: [String, Number],
    runningInApp: Boolean,
    shouldSetUserName: Boolean,
  },
  mounted() {
    if (!this.runningInApp) {
      if (adsbygoogle) { //eslint-disable-line
        (adsbygoogle = window.adsbygoogle || []).push({}); //eslint-disable-line
      }
    }
  },
  data() {
    return {
      gameVersion: `${VERSION}`, //eslint-disable-line
    };
  },
};
</script>

<style lang="less">
.start-menu {
  border-radius: 5px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  font-size: 1.25rem;
  font-weight: 300;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  height: 100%;
  position: relative;

  .logo {
    margin-bottom: 8rem;
    display: flex;
    width: 100%;

    div {
      flex: 1;
      padding: .25rem;

      span {
        text-align: center;
        padding: 1rem 0;
        font-weight: bold;
        width: 100%;
        justify-content: center;
        background: #fff;
        box-shadow: 0 5px 0 darken(#fff, 15%);
        color: #333;
      }
    }
  }

  .online-clients {
    margin-top: 2rem;
  }

  .game-version {
    text-align: center;
    padding: 1rem;
    font-size: .75rem;

    a {
      text-decoration: none;
      color: #fff;
    }
  }
  .ads {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding-top: 1rem;
    height: 5rem;
    width: 100%;
    font-size: .75rem;
  }

  .toolbar {
    width: 100%;
    margin-top: 2rem;
    i {
      font-size: 2rem;
      cursor: pointer;
      &.pulsate {
        -webkit-animation: pulsate 1s ease-out;
        -webkit-animation-iteration-count: 3;
      }

      &.disabled {
        opacity: .5;
        cursor: default;
      }
    }
    display: flex;
    justify-content: center;
    div {
      padding: 0 1.5rem;
    }

    a {
      color: #fff;
    }
  }
  span {
    padding: 1rem;

    font-size: 1rem;
    font-weight: 300; // color: #333;
    display: flex;

    color: #fff;
    justify-content: center;
    align-items: center;
    position: relative;
    border-radius: 5px;
    display: inline-block;
    border: none;
  }

  .status-bar {
    display: flex;
    font-size: 2rem;
    font-weight: 300;
    padding: 1rem;
    align-items: center;
    justify-content: center;
    width: 100%;
    text-align: center;
    margin-top: 2rem;

    div {
      flex: 1;
    }

    p,
    span {
      text-transform: uppercase;
      font-size: .7rem;
      margin: 0;
    }
  }
}

.share {
  padding-top: 2.5rem;
  span {
    padding: 0;
  }
}

// .button {
//   border-radius: 5px;
//   color: #fff;
//   text-transform: uppercase;
//   font-weight: 700;
//   border: none;
//   padding: 1rem;
//   background: #C2185B;
//   margin-bottom: 2rem;
//   text-decoration: none;
//   text-align: center;
//   cursor: pointer;
//   box-shadow: 0 5px 0 darken(#C2185B, 15%);
//   transition: all ease .3s;
//   width: 100%;
//   &:hover {
//     background: lighten(#C2185B, 5%);
//   }
//   &:active,
//   &focus {
//     outline: none;
//     box-shadow: 0 2px 0 darken(#C2185B, 15%);
//   }
//   &.blue {
//     background: #1976D2;
//     box-shadow: 0 5px 0 darken(#1976D2, 15%);
//     &:active,
//     &focus {
//       box-shadow: 0 2px 0 darken(#1976D2, 15%);
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// Start.vue?50905f3e